import { useNavigate } from 'react-router-dom'
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { IconName } from '../../../../shared/interfaces/icon-picker.model'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import ReleaseNotesService from '../../../../shared/services/release-notes/release-notes-service'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'
import { useContext, useEffect, useState } from 'react'
import { IReleaseNote } from '../../../../shared/services/release-notes/release-notes-model'
import { IHeadCell } from '../../../../shared/interfaces/table-display.model'
import { Chip, useMediaQuery } from '@mui/material'
import { LoadingPage } from '../../loading-page'
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display'
import gaiaTheme from '../../../../root-components/theme'
import moment from 'moment'

export const SuperAdminReleaseNotesPage = () => {
  const navigate = useNavigate()
  //Services
  const releaseNotesService = new ReleaseNotesService()
  // State
  const [releaseNotes, setReleaseNotes] = useState<IReleaseNote[]>([])
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [change, setChange] = useState<number>(0)
  const [orderBy, setOrderBy] = useState<string>()
  const [order, setOrder] = useState<'asc' | 'desc'>()
  //Loading State
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  //Use Effects
  useEffect(() => {
    getReleaseNotes()
  }, [inputPage, perPage, change])

  const getReleaseNotes = () => {
    releaseNotesService.getAllWithPagination(inputPage, perPage, orderBy, order)
      .then(response => {
        setIsLoading(false)
        setTotalRecords(response.count);
        setReleaseNotes(response.rows)
      })
      .catch(err => {
        setIsLoading(false)
        console.log(err)
      })
  }

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [order, orderBy])

  const headCells: IHeadCell[] = [
    { id: 'title', numeric: false, label: 'Title', sortable: true, isHeading: true },
    { id: 'releasedDate', numeric: false, label: 'Released Date', sortable: true },
    { id: 'status', numeric: false, label: 'Status', sortable: true },
    { id: 'released', numeric: false, label: 'Released', sortable: false },
  ]

  const rows = !releaseNotes ? [] : releaseNotes.map(releaseNote => {
    return {
      id: releaseNote.id,
      title: releaseNote.title,
      releasedDate: moment(releaseNote.releasedDate).format('DD/MM/YYYY'),
      status: releaseNote.status,
      released: releaseNote.released ? <Chip label='Released' color='success' variant='outlined' sx={{ width: '130px' }} /> : <Chip label='Not Released' color='error' variant='outlined' sx={{ width: '130px' }} />,
    }
  })

  const handleOrderChange = (orderBy: string, order: 'asc' | 'desc',) => {
    setOrderBy(orderBy)
    setOrder(order)
  };

  const handleSelected = (selectedRowId: string[]) => {
    if (selectedRowId[0] !== undefined) {
      navigate(`/super-admin/release-notes/${selectedRowId[0]}`)
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Release Notes'
        includeBackButton={true}
        backButtonLink={'/super-admin'}
        backButtonText='Back to super admin'
        includeActionButton={true}
        actionButtonText='Add Release Note'
        actionButtonIcon={IconName.Add}
        actionButtonHandler={() => { navigate('/super-admin/release-notes/add') }}
      />
      <LoadingPage pageReady={!isLoading}>
        <TableDisplay
          onOrderChange={handleOrderChange}
          isMobileMode={isMobileMode}
          headCells={headCells}
          rows={rows}
          handleSelected={handleSelected}
          selected={selected}
          setSelected={setSelected}
          inputPage={inputPage}
          setInputPage={setInputPage}
          totalRecords={totalRecords}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </LoadingPage>
    </PageOuterContainer>
  )
}